<template>
  <base-text-field :value="value" :label="label" :placeholder="placeholder" :rules="internalRules" :required="required" ref="input" @input="handleInput">
    <template #prefix>
      {{ selectedRegion.label }}
    </template>
  </base-text-field>
</template>

<script>
const formatter = require("google-libphonenumber").PhoneNumberFormat;
const phoneUtil = require("google-libphonenumber").PhoneNumberUtil.getInstance();
import BaseTextField from "@/components/base/BaseTextField";
import Cleave from "cleave.js";
import "cleave.js/dist/addons/cleave-phone.us";

export default {
  components: {
    BaseTextField,
  },
  props: {
    value: [String, Number],
    label: String,
    placeholder: String,
    rules: {
      type: Array,
      default: () => [],
    },
    required: Boolean,
  },
  data() {
    return {
      cleave: null,
      selectedRegionCode: this.value ? phoneUtil.getRegionCodeForNumber(phoneUtil.parseAndKeepRawInput(this.value)) : "US",
      rawInput: this.value ? phoneUtil.parse(this.value).getNationalNumber() : null,
      regions: [{ region: "US", label: "US +1", prefix: "+1" }, { region: "PR", label: "PR +1", prefix: "+1" }],
    };
  },
  computed: {
    selectedRegion() {
      return this.regions.find((items) => items.region === this.selectedRegionCode) || {};
    },
    e164() {
      try {
        return phoneUtil.format(phoneUtil.parse(this.selectedRegion.prefix + this.rawInput), formatter.E164);
      } catch (error) {
        return "";
      }
    },
    isValid() {
      try {
        return phoneUtil.isValidNumber(phoneUtil.parse(this.e164));
      } catch (error) {
        return false;
      }
    },
    internalRules() {
      return [() => !!this.isValid || "Invalid Phone Number", ...this.rules];
    },
  },
  mounted() {
    this.cleave = new Cleave(this.$refs.input.$refs.input, {
      phone: true,
      phoneRegionCode: this.selectedRegionCode,
      delimiter: "-",
      onValueChanged: (e) => {
        this.$nextTick(() => {
          this.rawInput = e.target.rawValue;
          this.$emit("input", e.target.value);
          this.$emit("update:e164", this.e164);
        });
      },
    });

    this.cleave.setRawValue(this.rawInput);
  },
  beforeDestroy() {
    this.cleave.destroy();
  },
  methods: {
    handleInput(event) {
      if (event === null) {
        this.cleave.setRawValue(null);
      }
    },
  },
  watch: {
    value() {
      if (this.value) {
        try {
          this.rawInput = phoneUtil.parseAndKeepRawInput(this.value, this.selectedRegion.region).getNationalNumber();
          this.cleave.setRawValue(this.rawInput);
          // eslint-disable-next-line no-empty
        } catch (error) {}
      }
    },
  },
};
</script>
